module.exports = __webpack_public_path__ + "img/Flag_of_Sudan.a53d8173.svg";